module.exports = __webpack_public_path__ + "assets/life_add.21c1c921.svg";